import { reactive } from "vue";
import { loadLazyTextsContent } from "@/i18n/load-quiz-content";

export default {
    install: (app, options) => {
        app.config.globalProperties.$versions = reactive({
            current: {
                f: 1, // форма
                ver: 1, // quiz
                hp: 1, // стартовая страница
                l: 1, // лендинг
                p: 1 // апсейл
            },
            getQueryParams() {
                const queryParams = new URLSearchParams(window.location.search)

                return  {
                    ver: +queryParams.get('ver'),
                    l: +queryParams.get('l'),
                    hp: +queryParams.get('hp'),
                    f: +queryParams.get('f'),
                    p: +queryParams.get('p'),
                }
            },
            getStorageParams() {
                return {
                    ver: +localStorage.getItem('ver'),
                    l: +localStorage.getItem('l'),
                    hp: +localStorage.getItem('hp'),
                    f: +localStorage.getItem('f'),
                    p: +localStorage.getItem('p')
                }
            },
            setStorageVersions(versions) {
                Object.entries(versions).forEach(([key, value]) => {
                    localStorage.setItem(key, value)
                })
            },
            setVersions(versions = {}) {
                console.log(versions)
                const formattedVersions = typeof versions === 'string' ? JSON.parse(versions || "{}") : versions;

                const storageParams = this.getStorageParams()
                const queryParams = this.getQueryParams()

                this.current = {
                    ver:  queryParams.ver || storageParams.ver || formattedVersions?.ver || process.env.VUE_APP_VER,
                    l: queryParams.l || storageParams.l || formattedVersions?.l || process.env.VUE_APP_L,
                    hp: queryParams.hp || storageParams.hp || formattedVersions?.hp || process.env.VUE_APP_HP,
                    f:  queryParams.f || storageParams.f || formattedVersions?.f || process.env.VUE_APP_F,
                    p: queryParams.p || storageParams.p || formattedVersions?.p || process.env.VUE_APP_P,
                }
                this.setStorageVersions(this.current);
            },
            updateVersion(key, version) {
                this.current[key] = version
            },

            async loadContent(callback) {
                const payload = { quiz: this.current.ver, landing: this.current.l, upsell: this.current.p, home: this.current.hp };
                loadLazyTextsContent(payload, callback)
            }
        })
    }
}
